import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { ErrorBoundary } from "react-error-boundary";
import flagsmith from "flagsmith";
import { FlagsmithProvider } from "flagsmith/react";
import "./index.css";
import App from "./App/App";
import { store } from "./state/store";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary
      fallback={
        <div className="flex min-h-screen items-center justify-center p-8 text-sm">
          Something went wrong. Please refresh the page.
        </div>
      }
    >
      <FlagsmithProvider
        options={{
          environmentID: import.meta.env
            .VITE_REACT_APP_FLAGSMITH_ENVIRONMENT_ID,
        }}
        flagsmith={flagsmith}
      >
        <Provider store={store}>
          <App />
        </Provider>
      </FlagsmithProvider>
    </ErrorBoundary>
  </StrictMode>,
);
